<template>
  <div class="model-settings">
    <settings-preview
      v-if="!inEditMode"
      :nluModel="getCurrent"
      :defaultImage="defaultImage"
      :isDeleting="isDeleting"
      :isExporting="isExporting"
      @edit="inEditMode = true"
      @delete="deleteModel"
      @export="exportKbHandler"
    >
      <template #culture>
        <div v-if="showCulture" class="model-culture">
          <img :src="flag" :alt="langLabel" /> {{ langLabel }}
        </div>
      </template>
    </settings-preview>
    <settings-edit
      v-else
      :isEditing="isModelUpdating"
      :isDeleting="isDeleting"
      :nluModel="getCurrent"
      :defaultImage="defaultImage"
      @edit="updateModel"
      @delete="deleteModel"
      @cancel="inEditMode = false"
    >
      <template #culture>
        <div v-if="showCulture" class="model-culture">
          <img :src="flag" :alt="langLabel" /> {{ langLabel }}
        </div>
      </template>
    </settings-edit>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { languages } from '@/modules/luis-languages'
import { flags } from '@/modules/language-flags-mapping'
import SettingsPreview from './settings-preview'
import SettingsEdit from './settings-edit'
import { downloadFile } from '@/utils/utils'

export default {
  components: {
    SettingsPreview,
    SettingsEdit
  },

  data () {
    return {
      isExporting: false,
      inEditMode: false,
      isDeleting: false,
      isModelUpdating: false,
      defaultImage:
        'https://qa-filesanddata-asset-manager-xux8mqnqka.s3-us-west-2.amazonaws.com/6ceadd6c-dbe3-4cb6-8643-889e8d339c77/nlu-ui/kb-default.png'
    }
  },

  computed: {
    ...mapGetters('knowledgebase', ['getCurrent']),

    showCulture () {
      return !_.isEmpty(this.getCurrent.extensions) && this.getCurrent.culture
    },

    langLabel () {
      const language = _.find(
        languages,
        item => _.toLower(item.value) === _.toLower(this.getCurrent.culture)
      )

      return !_.isEmpty(language) ? language.label : ''
    },

    flag () {
      return _.find(flags, ['value', _.toLower(this.getCurrent.culture)]).flag
    }
  },

  methods: {
    ...mapActions('knowledgebase', [
      'updateNluModelSettings',
      'exportKnowledgeBase',
      'deleteKnowledgeModel'
    ]),
    ...mapActions('knowledgebase/notifications', ['addError']),

    async updateModel (updatedModel) {
      this.isModelUpdating = true
      try {
        // This is required. BE validate "name" to be unique one.
        // Therefore if you send unchanged name => it will return validation error "name should be unique one" -_-
        // TODO: Remove it or make generic util for diffs
        const updatedFields = {}
        if (updatedModel.name !== this.getCurrent.name) {
          updatedFields.name = updatedModel.name
        }
        if (updatedModel.desc !== this.getCurrent.desc) {
          updatedFields.desc = updatedModel.desc
        }
        if (updatedModel.imageSrc !== this.getCurrent.imageSrc) {
          updatedFields.imageSrc = updatedModel.imageSrc
        }

        await this.updateNluModelSettings(updatedFields)
        this.inEditMode = false
      } catch (err) {
        console.log(`Wasn't able to update ${this.getCurrent.id}: ${err}`)
      }

      this.isModelUpdating = false
    },

    async deleteModel () {
      this.isDeleting = true
      await this.deleteKnowledgeModel({ id: this.getCurrent.id })
      this.$router.push({ name: 'home' })
      this.isDeleting = false
    },

    async exportKbHandler () {
      this.isExporting = true
      try {
        const data = await this.exportKnowledgeBase({ id: this.getCurrent.id })
        downloadFile(data)
      } catch (error) {
        this.addError({
          titleLabel: 'settings.settings.exportKnowledgeModel',
          error: error.message
        })
      }
      this.isExporting = false
    }
  }
}
</script>

<style scoped lang="scss">
.model-settings {
  max-width: 500px;
  margin-top: $sp-5;
}
.model-culture {
  display: flex;
  align-items: center;
  margin: $sp-3 0;
  font-weight: bold;

  img {
    height: 32px;
    margin-right: $sp-3;
  }
}
</style>
